import {
  Close,
  ExitToApp,
  NavigateBefore,
  NavigateNext
} from '@mui/icons-material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel
} from '@mui/material';
import ButtonComponent from 'components/design-system/Button/Button';
import CheckboxComponent from 'components/design-system/Checkbox/Checkbox';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { useDialog } from 'hooks/useDialog';
import { useEffect } from 'react';
import imgRegistro from 'assets/images/ilustracion-registro.svg';
import { useHistory } from 'react-router-dom';
import { RUTAS } from 'const/Rutas';
// import { DialogoRechazarSolicitudAutorizacionAdministracion } from 'views/ConfirmarAdministracion/components/Confirmacion';

export const TerminosYCondiciones = ({
  onVolver,
  onContinuar,
  isSubmiting,
  terminosAceptados,
  setTerminosAceptados,
  values,
  setFieldValue,
  setFieldTouched,
  touched,
  resetForm,
  onRechazarSolicitud
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const history = useHistory();
  const { open, onClose, onOpen } = useDialog();

  // Se actualiza el valor del campo 'accion' dependiendo de si se aceptaron los términos o no
  useEffect(() => {
    setFieldValue('accion', terminosAceptados ? 'aceptar' : 'rechazar');
  }, [setFieldValue, terminosAceptados]);

  const Section = ({ number, title, children, level = 1 }) => {
    const HeadingTag = `h${level + 3}`; // h4 for level 1, h5 for level 2, h6 for level 3

    // Mapeo de indentación por nivel
    const indentClass =
      {
        1: 'pl-0',
        2: 'pl-4',
        3: 'pl-8',
        4: 'pl-12'
      }[level] || 'pl-16'; // niveles mayores siguen aumentando

    return (
      <div className={`section level-${level} mb-4 ${indentClass}`}>
        <Heading type={`h${level + 3}`}>
          {number} {title}
        </Heading>
        {children}
      </div>
    );
  };

  return (
    <>
      <div className="bg-background-primary p-5 sm:p-10 rounded max-h-[480px] overflow-y-scroll scrollbar-uv">
        <Heading type="h3">Términos y condiciones</Heading>
        <Section title="Disposiciones generales del servicio">
          <Text className="mb-4">
            Acceder a la Plataforma de Industria Circular como Asesor implica
            utilizarla como una herramienta de facilitación para la gestión de
            proyectos de economía circular de terceros. El Asesor asume la
            responsabilidad de actuar con la debida diligencia profesional y
            ética en todas sus interacciones y propuestas de negocio.
          </Text>

          <Section title="Funcionalidad y solicitud de negocio" level={2}>
            <Section title="1. Prohibición de uso indebido" level={3}>
              <Text className="mb-4">
                El Asesor se obliga a utilizar la función de{' '}
                <strong>“Solicitud de Negocio”</strong> exclusivamente para
                ofrecer servicios de consultoría relacionados con la economía
                circular y la simbiosis industrial a los usuarios registrados.
                Se prohíbe el uso de esta herramienta para cualquier otro fin,
                incluyendo la recolección de información de empresas para
                beneficios propios o ajenos.
              </Text>
            </Section>

            <Section title="2. Reserva de información" level={3}>
              <Text className="mb-4">
                Al enviar una solicitud de negocio, el Asesor tendrá acceso
                limitado a la información pública del usuario. La Plataforma se
                compromete a no divulgar información confidencial del usuario
                sin su consentimiento explícito.
              </Text>
            </Section>

            <Section title="3. Responsabilidad de la propuesta" level={3}>
              <Text className="mb-4">
                El Asesor es el único responsable por la veracidad y calidad de
                la propuesta de servicio presentada. La Plataforma no interviene
                en la negociación, el acuerdo comercial o la ejecución de los
                servicios pactados entre el Asesor y el usuario.
              </Text>
            </Section>
          </Section>

          <Section
            title="Confidencialidad y manejo de la información"
            level={2}
          >
            <Section title="1. Reserva estricta" level={3}>
              <Text className="mb-4">
                El Asesor debe mantener la estricta reserva respecto a toda la
                información de los usuarios que conozca a través de la
                Plataforma. Esto incluye documentos, datos de contacto y
                detalles sobre flujos de residuos o recursos que no sean de
                carácter público.
              </Text>
            </Section>

            <Section title="2. No divulgación a terceros" level={3}>
              <Text className="mb-4">
                El Asesor se compromete a no divulgar, bajo ninguna
                circunstancia, la información de un usuario a un tercero,
                incluyendo a otros clientes o prospectos, sin la autorización
                expresa y por escrito de la empresa involucrada.
              </Text>
            </Section>

            <Section title="3. Uso de datos" level={3}>
              <Text className="mb-4">
                El Asesor podrá usar la información de los usuarios únicamente
                para el fin específico de la propuesta de servicio. Los datos
                obtenidos no podrán ser almacenados, procesados o utilizados
                para otros fines fuera de la Plataforma.
              </Text>
            </Section>
          </Section>

          <Section title="Aceptación y responsabilidad" level={2}>
            <Text className="mb-4">
              Al enviar una <strong>“Solicitud de Negocio”</strong>, el Asesor
              acepta y se compromete a cumplir plenamente con estos términos y
              condiciones. El incumplimiento de estas normas de confidencialidad
              y uso de información puede resultar en la suspensión de la cuenta
              del Asesor y en acciones legales.
            </Text>
          </Section>
        </Section>
        <FormControlLabel
          control={
            <CheckboxComponent
              disabled={isSubmiting}
              name="codigosTipoResiduo"
              value={terminosAceptados}
              onChange={(event, value) => setTerminosAceptados(value)}
              checked={terminosAceptados}
            />
          }
          label={
            <Text className="font-bold text-black ml-2">
              Acepto los términos y condiciones
            </Text>
          }
        />
      </div>
      <div className="absolute bottom-0 w-full shadow-md rounded-bl rounded-br bg-white px-4 sm:px-10 py-4 border-t left-0">
        <div className="flex justify-end">
          <div>
            <ButtonComponent
              form="form"
              onClick={() => {
                onRechazarSolicitud();
                onOpen();
              }}
              isLoading={isSubmiting}
              disabled={isSubmiting || terminosAceptados}
              variant="contained"
              hidden={terminosAceptados}
              className="!bg-error-dark hover:!bg-error-dark"
            >
              Rechazar{' '}
              <span className="hidden md:block ml-1">
                solicitud <Close />
              </span>
            </ButtonComponent>
          </div>
          <div>
            <ButtonComponent
              form="form"
              onClick={() => {
                onContinuar();
              }}
              isLoading={isSubmiting}
              disabled={isSubmiting || !terminosAceptados}
              variant="contained"
              hidden={!terminosAceptados}
              className="mr-4"
            >
              Continuar <span className="hidden md:block ml-1"></span>
              <NavigateNext />
            </ButtonComponent>
          </div>
        </div>
      </div>
      <DialogoRechazarSolicitudAutorizacionAdministracion
        open={open}
        onClose={() => {
          onClose();
          onVolver();
        }}
        onSubmitDialog={() => {
          history.push(RUTAS.REGISTRARSE);
        }}
      />
    </>
  );
};

export const DialogoRechazarSolicitudAutorizacionAdministracion = ({
  open,
  onClose,
  onSubmitDialog
}) => {
  return (
    <Dialog fullWidth open={open} onClose={onClose} maxWidth={'sm'}>
      <DialogTitle id="alert-dialog-title text">
        <Heading type="h3" className="mb-0">
          Invitacion de registro
        </Heading>
      </DialogTitle>
      <DialogContent className="h-full relative overflow-hidden px-4">
        <div className="grid grid-cols-12 gap-2 items-center">
          <div className="col-span-6 p-5  hidden md:block">
            <img src={imgRegistro} alt="" />
          </div>
          <div className="col-span-12 md:col-span-6 ">
            <Text>
              Te dejamos cordialmente invitado a registrarte en nuestra
              plataforma, al registrar un usuario te permitirá posteriormente
              acceder a la plataforma a visualizar también la información del
              negocio.
            </Text>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="border-t border-neutral-90 p-4">
        <div className="flex justify-between w-full gap-4">
          <ButtonComponent type="secondary" onClick={onClose}>
            <Close /> <span className="hidden sm:inline-block">Cancelar</span>
          </ButtonComponent>
          <ButtonComponent
            type="primary"
            onClick={onSubmitDialog}
            autoFocus
            className="w-full xs:w-auto"
          >
            Ir a registro
            {'  '}
            <ExitToApp />
          </ButtonComponent>
        </div>
      </DialogActions>
    </Dialog>
  );
};
